import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
  signal,
  ViewEncapsulation,
  WritableSignal,
} from '@angular/core';


import { ButtonComponent, FormFieldComponent } from '@akostm/orbit-ui';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LogInCredentials } from '../../../interfaces';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { IdentityStore } from '../../../stores';
import { AuthenticationOptions } from '@clientwire/api';

@Component({
  selector: 'shared-login-form',
  standalone: true,
  imports: [FormFieldComponent, ButtonComponent, ReactiveFormsModule, TranslatePipe],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent {
  readonly #router = inject(Router);
  readonly #identityStore = inject(IdentityStore);
  authenticationOptions: WritableSignal<AuthenticationOptions | null> = signal(null);
  loginAttempt = output<LogInCredentials>();
  resetLogin = output<void>();

  loginForm = new FormGroup({
    email: new FormControl<string | null>(null),
    password: new FormControl<string | null>(null),
  });

  get email() {
    return this.loginForm.get('email') as FormControl<string>;
  }

  get password() {
    return this.loginForm.get('password') as FormControl<string>;
  }

  onSubmit() {
    if (this.authenticationOptions() === null) {
      this.onProceed();
    } else {
      const givenCredentials = { email: this.email.value, password: this.password.value };
      this.loginAttempt.emit(givenCredentials);
    }
  }

  formIsValid(): boolean {
    return !!this.email.value
  }

  forgotPassword() {
    if (this.email.value !== null) {
      this.#router.navigate([`/reset-password`], {
        queryParams: {
          email: this.email.value,
        },
      });
    } else {
      this.#router.navigate([`/reset-password`]);
    }
  }

  signInWithOidcProvider(authorityUrl: string) {
    window.open(authorityUrl, '_self');
  }

  onProceed() {
    this.#identityStore
      .getSignInOptions(this.email.value)
      .then((result: AuthenticationOptions) => {
        this.authenticationOptions.set(result);
      })
      .catch(() => {
        this.authenticationOptions.set({ email: true, oidcProviders: [] });
      });
  }

  backToEmail() {
    this.authenticationOptions.set(null);
    this.loginForm.reset();
    this.resetLogin.emit();
  }
}
